import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.small";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import isEmpty from 'lodash/isEmpty';
import { formatImageCloudinary } from '~/helpers/image-helper';
import { EMPTY_PIXEL } from '~/const/images';
import Accordion from '~/components/molecules/Accordion';
export default {
  name: 'ProductDescription',
  components: {
    Accordion
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      toggle: {
        description: true,
        complementary: false,
        additional: false,
        range: false
      }
    };
  },

  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    hasMaterialsImage() {
      if (!isEmpty(this.payload.additionalInformation.additionalContent.image)) {
        var _ref, _ref2, _ref3;

        return {
          material_image: {
            image: {
              small: formatImageCloudinary((_ref3 = this.payload) != null ? (_ref3 = _ref3.additionalInformation) != null ? (_ref3 = _ref3.additionalContent) != null ? (_ref3 = _ref3.image) != null ? _ref3.small : _ref3 : _ref3 : _ref3 : _ref3, ['q_auto,f_auto', 'w_200']) || EMPTY_PIXEL,
              large: formatImageCloudinary((_ref2 = this.payload) != null ? (_ref2 = _ref2.additionalInformation) != null ? (_ref2 = _ref2.additionalContent) != null ? (_ref2 = _ref2.image) != null ? _ref2.large : _ref2 : _ref2 : _ref2 : _ref2, ['q_auto,f_auto', 'w_500']) || EMPTY_PIXEL,
              alt: ((_ref = this.payload) != null ? (_ref = _ref.additionalInformation) != null ? (_ref = _ref.additionalContent) != null ? (_ref = _ref.image) != null ? _ref.alt : _ref : _ref : _ref : _ref) || ''
            }
          }
        };
      }

      return false;
    },

    hasDescriptionMain() {
      return Boolean(!isEmpty(this.payload.description.main));
    },

    hasAdditionalContent() {
      return Boolean(!isEmpty(this.payload.additionalInformation.additionalContent));
    },

    hasInfoCompContent() {
      return Boolean(!isEmpty(this.payload.additionalInformation.infoCompDescription));
    },

    hasProductRange() {
      return Boolean(!isEmpty(this.payload.description.line) || !isEmpty(this.payload.line));
    },

    productRangeUrl() {
      return this.buildSearchUrl(this.locale, this.payload.line);
    }

  }),
  methods: {
    handleClick(event, arg) {
      this.toggle[arg] = !this.toggle[arg];
      Object.keys(this.toggle).filter(e => e !== arg).forEach(e => {
        this.toggle[e] = false;
      });
      this.handleTracking(event, arg);
    },

    handleTracking(event, arg) {
      if (arg === 'description') {
        this.$root.$emit('generic-tracking', event, {
          fn: 'track-event',
          data: {
            event_category: 'FicheProduit',
            event_action: this.toggle[arg] ? 'Clic_derouler_description' : 'Clic_reduire_description',
            event_label: "".concat(window.tc_vars.product_activity, "/").concat(window.tc_vars.page_cat2, "/").concat(window.tc_vars.page_cat3, "/").concat(window.tc_vars.page_cat4, "/").concat(window.tc_vars.page_cat5)
          }
        });
      }

      if (arg === 'complementary') {
        this.$root.$emit('generic-tracking', event, {
          fn: 'track-event',
          data: {
            event_category: 'FicheProduit',
            event_action: this.toggle[arg] ? 'Clic_derouler_infos' : 'Clic_reduire_infos',
            event_label: "".concat(window.tc_vars.product_activity, "/").concat(window.tc_vars.page_cat2, "/").concat(window.tc_vars.page_cat3, "/").concat(window.tc_vars.page_cat4, "/").concat(window.tc_vars.page_cat5)
          }
        });
      }

      if (arg === 'additional') {
        this.$root.$emit('generic-tracking', event, {
          fn: 'track-event',
          data: {
            event_category: 'FicheProduit',
            event_action: 'Clic_sheesham',
            event_label: "".concat(window.tc_vars.product_activity, "/").concat(window.tc_vars.page_cat2, "/").concat(window.tc_vars.page_cat3, "/").concat(window.tc_vars.page_cat4, "/").concat(window.tc_vars.page_cat5)
          }
        });
      }

      if (arg === 'range') {
        this.$root.$emit('generic-tracking', event, {
          fn: 'track-event',
          data: {
            event_category: 'FicheProduit',
            event_action: 'Clic_gamme',
            event_label: this.payload.line
          }
        });
      }
    }

  }
};